const labelsEN = {
    "view": {
        "table": {
            "title": "Your labels list",
            "column": {
                "name": "Name",
                "owner": "Owner",
                "company": "Company",
                "contract": "Contract",
                "info": "Info",
                "status": "Status",
                "action": "Action"
            },
            "button": {
                "edit": "Edit",
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
            "label": {
                "approved": "Approved",
                "waiting_approval": "Waiting Approval"
            }
        },
        "message": {
            "success": "Label has been removed!",
            "error": "Something went wrong! Please refresh page and try again!",
            "notSubscribed": "You are not subscribed to any plan, therefore you can only add <strong>3 Labels</strong>, Please <3>subscribe</3> to a plan to avail unlimited amount of Labels.",
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        },
        "modal": {
            "delete": {
                "header": "Delete label {{labelName}}?",
                "body": "Are you sure you want to delete label {{labelName}}? This action cannot be undone."
            },            
        }
    },
    "add": {
        "title": "Add Label",
        "form": {
            "label": {
                "required": "Required",
                "name": "Name",
                "subuser": "Sub-User",
                "logo": "Logo",
                "promo_graphic": "Promotional Graphic",
                "primary_genre": "Primary genre",
                "secondary_genre": "Secondary genre",
                "year_established": "Year Established",
                "releases_in_catalog": "Releases in catalog",
                "soundcloud": "Soundcloud",
                "website": "Website",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "subuser": "Note: Only use this dropdown if you want to Add Label for any of your Sub-users otherwise leave un-selected.",
                "logo": "Upload JPG or PNG formats, resolution only 1000x1000 px",
                "promo_graphic": "Upload JPG or PNG formats, resolution only 960x150px, max 100kb"
            },
            "placeholder": {
                "subuser": "Select Sub-user..."
            },
            "button": {
                "reset": "Reset",
                "submit": "Submit"
            },
            "message": {
                "success": "Label has been added!",
                "error": "Something went wrong! Please refresh page and try again!"
            }
        },
        "modal": {
            "addLabel": {
                "header": "Add Label {{labelName}}?",
                "body":"Are you sure you want to create a new label? Please make sure you are inserting a unique label name. In order to be sure, please check if the name already exists in stores like Beatport and Traxsource. Every submission has to be approved and registered by the Music Link team. We usually approve and registered new labels within 48 hours.",
                "button": {
                    "confirm": "Confirm",
                    "cancel": "Cancel"
                }
            }
        },
        "message": {
            "success": "Label has been added!",
            "error": "Something went wrong! Please refresh page and try again!"
        }
    },
    "update": {
        "title": "Edit Label",
        "form": {
            "label": {
                "required": "Required",
                "name": "Name",
                "logo": "Logo",
                "promo_graphic": "Promotional Graphic",
                "primary_genre": "Primary genre",
                "secondary_genre": "Secondary genre",
                "year_established": "Year Established",
                "releases_in_catalog": "Releases in catalog",
                "soundcloud": "Soundcloud",
                "website": "Website",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "youtube": "Youtube",
                "instagram": "Instagram",
                "mixcloud": "Mixcloud",
                "beatport": "Beatport"
            },
            "help_text": {
                "logo": "Upload JPG or PNG formats, resolution only 1000x1000 px",
                "promo_graphic": "Upload JPG or PNG formats, resolution only 960x150px, max 100kb"
            },
            "placeholder": {
            },
            "button": {
                "submit": "Submit"
            },
            "message": {
                "success": "Label has been updated!",
                "error": "Something went wrong! Please refresh page and try again!"
            }
        }
    }
};

export default labelsEN;